/**
 * ThemeSandbox — forma y color, con vista previa.
 *
 * Los dos ejes del aspecto son independientes: skin (forma) y paleta (color).
 * Aquí se ve por qué. No guarda nada ni toca la preferencia real.
 */

import React, { useState } from 'react';

const SHAPES = [
  { id: 'clasico', label: 'Clásico', radius: 8, shadow: '0 2px 6px rgba(15,23,42,.12)', density: 'normal' },
  { id: 'cristal', label: 'Cristal', radius: 18, shadow: '0 18px 40px rgba(15,23,42,.28)', density: 'normal' },
  { id: 'compacto', label: 'Compacto', radius: 4, shadow: '0 1px 2px rgba(15,23,42,.18)', density: 'compacta' },
];

const PALETTES = [
  { id: 'azul', label: 'Azul', color: '#2563eb' },
  { id: 'verde', label: 'Verde', color: '#059669' },
  { id: 'violeta', label: 'Violeta', color: '#7c3aed' },
  { id: 'ambar', label: 'Ámbar', color: '#d97706' },
];

export default function ThemeSandbox() {
  const [shapeId, setShapeId] = useState('clasico');
  const [paletteId, setPaletteId] = useState('azul');

  const shape = SHAPES.find((item) => item.id === shapeId) || SHAPES[0];
  const palette = PALETTES.find((item) => item.id === paletteId) || PALETTES[0];
  const compact = shape.density === 'compacta';

  return (
    <div className="act-frame" style={{ '--act-accent': palette.color }}>
      <div className="act-controls">
        <div className="act-group">
          <span className="act-group-title">Estilo (forma)</span>
          <div className="act-options">
            {SHAPES.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`act-option${item.id === shapeId ? ' is-active' : ''}`}
                onClick={() => setShapeId(item.id)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="act-group">
          <span className="act-group-title">Paleta (color)</span>
          <div className="act-options">
            {PALETTES.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`act-color${item.id === paletteId ? ' is-active' : ''}`}
                style={{ background: item.color }}
                onClick={() => setPaletteId(item.id)}
                title={item.label}
                aria-label={item.label}
              />
            ))}
          </div>
        </div>
      </div>

      <div
        className={`act-preview${compact ? ' is-compact' : ''}`}
        style={{ borderRadius: shape.radius, boxShadow: shape.shadow }}
      >
        <div className="act-preview-head">
          <span className="act-preview-dot" />
          <span className="act-preview-title">Racks</span>
          <span className="act-preview-action">Nuevo rack</span>
        </div>
        <div className="act-preview-row"><span>RACK-A · C.P. Central</span><span>12 / 42 U</span></div>
        <div className="act-preview-row"><span>RACK-B · C.P. Central</span><span>8 / 42 U</span></div>
        <div className="act-preview-row"><span>RACK-N1 · Sede Norte</span><span>4 / 24 U</span></div>
      </div>

      <p className="act-hint">
        En <strong>Mi perfil</strong> los dos ejes se eligen por separado y se guardan en tu usuario.
        Si la empresa fija un aspecto, puedes volver a heredarlo desde el mismo sitio.
      </p>
    </div>
  );
}
